import Blob from 'blob';
import { getWindow } from './general';
export var parseBlob = function (blobText, contentType) {
    return new Blob([blobText], { type: contentType });
};
// Open file in new tab.
export var openFile = function (blob, fileName) {
    /**  // IE - can probably be depercated since IE is not supported anymore
     *
     * if (window.navigator.msSaveBlob) {
     
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
     */
    var aElement = document.createElement('a');
    document.body.appendChild(aElement);
    aElement.setAttribute('style', 'display: none');
    var url = (window.URL || window.webkitURL).createObjectURL(blob);
    aElement.href = url;
    aElement.download = fileName;
    aElement.click();
    setTimeout(function () {
        aElement.remove();
    }, 100);
};
// Save file to downloads folder.
export var saveFile = function (blob, fileName) {
    /* if (window.navigator.msSaveBlob) {
      // IE - can probably be depercated since IE is not supported anymore
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else { */
    var aElement = document.createElement('a');
    document.body.appendChild(aElement);
    aElement.setAttribute('style', 'display: none');
    var url = (window.URL || window.webkitURL).createObjectURL(blob);
    aElement.href = url;
    aElement.download = fileName;
    aElement.click();
    setTimeout(function () {
        if (getWindow())
            window.URL.revokeObjectURL(url);
        aElement.remove();
    }, 100);
};
/**
 * Clear Recently Viewed data from sessionStorage so new user will not see old user viewing history
 */
export var clearSessionStorageRVData = function () {
    sessionStorage.removeItem('rvData');
    sessionStorage.removeItem('RVDateStamp');
};
export var redirectToB2BHomePage = function () {
    var _a;
    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.assign('https://www.homedepot.com'); // `https://www.homedepot.com${B2B_HOMEPAGE_PATH}`
};
export var redirectToSignIn = function () {
    var _a, _b;
    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.replace("/auth/view/signin?redirect=".concat(window.location.pathname).concat((_b = window === null || window === void 0 ? void 0 : window.location) === null || _b === void 0 ? void 0 : _b.search));
};
export var redirectToSignInWithCustomRedirect = function (redirectUrl) { var _a; return (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.replace("/auth/view/signin?redirect=".concat(redirectUrl)); };
export var redirectGuestOrderTracking = function () {
    window.location.replace('/myaccount/guest-order-tracking');
};
export var redirecToErrorPage = function () {
    var _a;
    (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.location.replace("/error");
};
